// GR-4097: wall-clock date arithmetic for the template pickers' previews.
//
// A datetime-local value is a time on the event's clock, but `new Date(value)`
// reads it in the browser's zone, so a preview built that way shifts with
// whoever is looking at it. These helpers hold the wall-clock value in a UTC
// Date instead and only ever use the UTC accessors, so the browser's zone (and
// its daylight saving changes) never comes into it.

// "YYYY-MM-DDTHH:MM" -> a Date whose UTC fields are that wall clock. Null when
// the value is blank or not in that shape.
export function parseWallClock(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}))?/.exec(value || "");
  if (!match) return null;

  const [, year, month, day, hours = "0", minutes = "0"] = match;
  return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hours), Number(minutes)));
}

export function shiftDays(date, days) {
  const shifted = new Date(date.getTime());
  shifted.setUTCDate(shifted.getUTCDate() + days);
  return shifted;
}

// Mirrors Event::RegistrationCloseRule: the given weekday (1 = Monday) of the
// Monday-start week `weeks_before` weeks ahead of the event's own week, at
// `time` ("HH:MM").
export function weekdayBefore(start, rule) {
  const daysSinceMonday = (start.getUTCDay() + 6) % 7;
  const closes = shiftDays(start, -daysSinceMonday - rule.weeks_before * 7 + (rule.weekday - 1));
  const [hours, minutes] = rule.time.split(":").map(Number);
  closes.setUTCHours(hours, minutes, 0, 0);
  return closes;
}

// "Mon 12 Oct 2026", read off the UTC fields.
export function formatWallClock(date) {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "UTC",
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
  }).formatToParts(date);
  const part = (type) => parts.find((p) => p.type === type).value;

  return `${part("weekday")} ${part("day")} ${part("month")} ${part("year")}`;
}
